import { Z_INDEX } from '@/constants';
import { cn } from '@/lib/utils';
import { AnyTagFilterProps } from '@/services/types/globals.type';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

interface SearchSelectProps extends AnyTagFilterProps {
  disabled?: boolean;
}

export default function SearchSelect({
  triggerPlaceholder,
  selected,
  list,
  onFilterChange,
  triggerAddClass,
  itemAddClass,
  disabled,
}: SearchSelectProps) {
  const selectedValue = selected ? selected[0]?.value : undefined;

  return (
    <Select
      disabled={disabled || list.length === 0}
      value={selectedValue || ''}
      onValueChange={(value) => {
        // list에서 value와 일치하는 객체를 찾음
        const selectedItem = list.find((item) => item.value === value);
        if (selectedItem) {
          onFilterChange(selectedItem);
        }
      }}
    >
      <SelectTrigger
        className={cn(
          'border-stroke-white [&>span]:text-level-3 relative z-50 h-full w-full justify-start rounded-md bg-white py-1 focus:outline-none [&>span]:text-[18px] [&>span]:font-semibold [&>svg]:hidden',
          triggerAddClass ?? '',
        )}
        data-size="default"
      >
        <SelectValue placeholder={triggerPlaceholder} />
        <img
          src="/images/icons/selector_arrow.svg"
          alt="화살표"
          className="pointer-events-none absolute top-1/2 right-2 size-5.5 -translate-y-1/2"
        />
      </SelectTrigger>
      <SelectContent
        style={{
          zIndex: Z_INDEX.Modal,
        }}
        className="border-stroke-white z-50 bg-white"
      >
        {list?.map((item) => (
          <SelectItem
            key={item.value}
            value={item.value}
            className={cn(itemAddClass ?? '')}
          >
            <span className="text-level-3 typo-18 py-1 font-semibold">
              {item.label}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
